import styled, { css } from 'styled-components';
import { Modal } from 'src/components';

export const WideModal = styled(Modal)(
  ({ theme }) => css`
    .reactModalContent {
      max-width: ${theme.sz.ml};
    }
  `,
);

export const ModalContent = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    color: ${theme.co.secondary50};
    padding: ${theme.sz.s4} ${theme.sz.s4} ${theme.sz.s6};
    gap: ${theme.sz.s4};
  `,
);

export const Header = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    box-sizing: border-box;
    width: 100%;
    min-height: ${theme.sz.s12};
    padding: ${theme.sz.s2} ${theme.sz.s12} ${theme.sz.s0} ${theme.sz.s6};
  `,
);

export const Title = styled.h2(
  ({ theme }) => css`
    margin: ${theme.sz.s0};
    width: 100%;
    text-align: left;
    color: ${theme.co.secondary20};
    ${theme.typography.heading.mobile.s};

    @media (min-width: ${theme.sz.md}) {
      ${theme.typography.heading.desktop.s};
    }
  `,
);

export const Description = styled.p(
  ({ theme }) => css`
    margin: ${theme.sz.s0};
    padding: ${theme.sz.s0} ${theme.sz.s0} ${theme.sz.s4};
    color: ${theme.co.secondary50};
    ${theme.typography.paragraph.base};
  `,
);

export const DontShowAgain = styled.label(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.sz.s2};
    cursor: pointer;
  `,
);

export const SmallCheckbox = styled.input.attrs({ type: 'checkbox' })(
  ({ theme }) => css`
    appearance: none;
    box-sizing: border-box;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: ${theme.sz.s3};
    height: ${theme.sz.s3};
    margin: ${theme.sz.s0};
    border: ${theme.sz.s05} solid ${theme.co.neutral20};
    border-radius: ${theme.bo.extraSmall};
    background-color: ${theme.co.neutral99};
    cursor: pointer;

    &:checked {
      border-color: ${theme.co.secondary0};
      background-color: ${theme.co.secondary0};
    }

    &:checked::after {
      content: '';
      box-sizing: border-box;
      width: ${theme.sz.s1};
      height: ${theme.sz.s2};
      margin-top: ${theme.sz.s05};
      border: solid ${theme.co.neutral99};
      border-width: 0 ${theme.sz.s05} ${theme.sz.s05} 0;
      transform: translateY(-${theme.sz.s05}) rotate(45deg);
    }
  `,
);

export const DontShowAgainText = styled.span(
  ({ theme }) => css`
    color: ${theme.co.secondary50};
    ${theme.typography.paragraph.s};
  `,
);

export const Actions = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    padding: ${theme.sz.s0} ${theme.sz.s6};
    box-sizing: border-box;
    gap: ${theme.sz.s3};
  `,
);

export const RemainLink = styled.button(
  ({ theme }) => css`
    display: block;
    width: 100%;
    padding: ${theme.sz.s1} ${theme.sz.s0};
    border: none;
    background: none;
    cursor: pointer;
    text-align: center;
    text-decoration: underline;
    color: ${theme.co.secondary50};
    ${theme.typography.paragraph.base};
  `,
);
